/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'cross_product_search_dialog.atlas.tab_label': 'Atlas',
  'cross_product_search_dialog.bitbucket.tab_label': 'Bitbucket',
  'cross_product_search_dialog.confluence.tab_label': 'Confluence',
  'cross_product_search_dialog.google_drive.tab_label': 'Google Drive',
  'cross_product_search_dialog.google_drive.unauthenticated_prompt':
    "Vous pouvez travailler sur l'ensemble de vos fichiers Google Sheets, Docs, Slides et bien plus encore, sans jamais quitter Atlassian. Vous êtes le seul à bénéficier de cet accès.",
  'cross_product_search_dialog.jira.tab_label': 'Jira',
  'cross_product_search_dialog.opsgenie.tab_label': 'Opsgenie',
  'cross_product_search_dialog.recently_viewed_title': '{sectionTitle} récemment consultés',
  'cross_product_search_dialog.townsquare_globex_tab_label': 'Accueil',
  'cross_product_search_dialog.townsquare_recent_goals': 'Objectifs récents',
  'cross_product_search_dialog.townsquare_recent_help_links': "Liens d'aide récents",
  'cross_product_search_dialog.townsquare_recent_learnings_risks_decisions':
    'Apprentissages, risques et décisions récents',
  'cross_product_search_dialog.townsquare_recent_projects': 'Projets récents',
  'cross_product_search_dialog.townsquare_tab_label': 'Atlas',
  'cross_product_search_dialog.trello.tab_label': 'Trello',
  'cross_product_search_dialog.view_all_results_link': 'Afficher tous les {sectionTitle}',
  'extensible_search_dialog.advanced_search': 'Recherche avancée',
  'extensible_search_dialog.connect': 'Connecter',
  'extensible_search_dialog.connect_to': 'Connecté à',
  'global_search.jira.advanced_search_boards': 'Tableaux',
  'global_search.jira.advanced_search_filters': 'Filtres',
  'global_search.jira.advanced_search_issues': 'Tickets',
  'global_search.jira.advanced_search_label': 'Accédez à tous les :',
  'global_search.jira.advanced_search_people': 'Personnes',
  'global_search.jira.advanced_search_plans': 'Plans',
  'global_search.jira.advanced_search_projects': 'Projets',
  'global_search.jira.search_placeholder': 'Rechercher dans Jira',
  'global_search.jira.search_placeholder_experiment_jsw_enabled':
    'Rechercher des tickets, des tableaux, des projets et des filtres',
  'product_s earch_dialog.confluence.assignee_filters_find_more': 'Recherchez une personne assignée',
  'product_search_dialog.atlas.search_input_expanded_placeholder': 'Recherchez dans Atlas',
  'product_search_dialog.autocorrection.label': 'Essayez avec cette orthographe',
  'product_search_dialog.bitbucket.bitbucket_advanced_search': 'Rechercher du code dans {source}',
  'product_search_dialog.bitbucket.bitbucket_recent_repositories': 'Dépôts récemment mis à jour',
  'product_search_dialog.bitbucket.bitbucket_repositories_section_title': 'Dépôts',
  'product_search_dialog.bitbucket.expanded.input-placeholder': 'Recherche Bitbucket',
  'product_search_dialog.bitbucket.repository_heading': 'Dépôts',
  'product_search_dialog.common.site_filters': 'Filtrer par site',
  'product_search_dialog.compass.component_type.application': 'Application',
  'product_search_dialog.compass.component_type.capability': 'Fonctionnalité',
  'product_search_dialog.compass.component_type.cloud_resource': 'Ressource Cloud',
  'product_search_dialog.compass.component_type.data_pipeline': 'Pipeline de données',
  'product_search_dialog.compass.component_type.library': 'Bibliothèque',
  'product_search_dialog.compass.component_type.machine_learning_model': "Modèle d'apprentissage machine",
  'product_search_dialog.compass.component_type.other': 'Autre',
  'product_search_dialog.compass.component_type.service': 'Service',
  'product_search_dialog.compass.component_type.ui_element': "Élément d'interface utilisateur",
  'product_search_dialog.compass.component_type.website': 'Site web',
  'product_search_dialog.compass.components_section_heading': 'Composants',
  'product_search_dialog.compass.expanded.input-placeholder': 'Rechercher dans Compass',
  'product_search_dialog.compass.people_section_heading': 'Personnes',
  'product_search_dialog.compass.recently_viewed_components': 'Composants récemment consultés',
  'product_search_dialog.compass.recently_viewed_teams': 'Équipes récemment consultées',
  'product_search_dialog.compass.tab_label': 'Compass',
  'product_search_dialog.compass.teams_section_heading': 'Équipes',
  'product_search_dialog.compass.upsell_modal_cta_text': 'Télécharger Compass gratuitement',
  'product_search_dialog.compass.upsell_modal_description':
    'Cataloguez votre architecture logicielle en un seul endroit, afin que les équipes qui y travaillent puissent réduire le changement de contexte, trouver ce dont elles ont besoin plus rapidement et être plus productives. Que pensez-vous de cette expérience de développement ?',
  'product_search_dialog.compass.upsell_modal_description.bitbucket':
    "Consultez les propriétaires, les dépendances et les ressources d'aide pour vos dépôts en les associant à un catalogue logiciel central.",
  'product_search_dialog.compass.upsell_modal_heading':
    'Contrôlez la multiplication des logiciels pour que vos développeurs gardent le contrôle de leur temps',
  'product_search_dialog.compass.upsell_modal_heading.bitbucket': 'Intégrez plus de contexte à votre code',
  'product_search_dialog.compass.upsell_modal_learn_more_aria_label': 'En savoir plus sur Compass',
  'product_search_dialog.compass.upsell_modal_learn_more_link': 'En savoir plus',
  'product_search_dialog.compass.upsell_tab_title_lozenge': 'Nouveau',
  'product_search_dialog.compass.view_all_components_label': 'Afficher tous les composants',
  'product_search_dialog.compass.view_all_results_label': 'Afficher tous les résultats',
  'product_search_dialog.confluence.advanced_search_with_product_prefix': 'Recherche avancée Confluence',
  'product_search_dialog.confluence.clear_filters': 'Effacer les filtres',
  'product_search_dialog.confluence.content_section_heading': 'Contenu',
  'product_search_dialog.confluence.contributor_filters': 'Filtrer par contributeur',
  'product_search_dialog.confluence.contributor_filters_find_more': 'Recherchez un contributeur',
  'product_search_dialog.confluence.date_filter_title': 'Dernière mise à jour',
  'product_search_dialog.confluence.date_filter_today': "Aujourd'hui",
  'product_search_dialog.confluence.date_filter_yesterday': 'Hier',
  'product_search_dialog.confluence.date_filters_any': 'À tout moment',
  'product_search_dialog.confluence.date_filters_month': '30 derniers jours',
  'product_search_dialog.confluence.date_filters_week': '7 derniers jours',
  'product_search_dialog.confluence.date_filters_year': 'Année dernière',
  'product_search_dialog.confluence.empty_state_body_no_advanced_search':
    'Essayez différents mots-clés, moins nombreux ou plus généraux.',
  'product_search_dialog.confluence.empty_state_body_prequery_filters':
    'Nous ne trouvons aucun élément créé ou actualisé au cours des 90 derniers jours avec les filtres que vous avez sélectionnés.',
  'product_search_dialog.confluence.empty_state_body_title':
    "Nous n'avons trouvé aucun résultat correspondant à votre recherche.",
  'product_search_dialog.confluence.filters_applied': 'Il semble que vous avez appliqué certains filtres',
  'product_search_dialog.confluence.pages_blogs_attachments_section_heading': 'Pages, blogs et pièces jointes',
  'product_search_dialog.confluence.people_section_heading': 'Personnes',
  'product_search_dialog.confluence.search_input_expanded_placeholder': 'Rechercher sur Confluence',
  'product_search_dialog.confluence.search_input_expanded_placeholder_ai':
    'Recherchez ou posez des questions dans votre Confluence',
  'product_search_dialog.confluence.space_filters': 'Filtrer par espace',
  'product_search_dialog.confluence.space_filters_find_more': 'Recherchez un espace',
  'product_search_dialog.confluence.spaces_section_heading': 'Espaces',
  'product_search_dialog.confluence.typing_state_header_text': 'Rechercher du contenu dans Confluence',
  'product_search_dialog.empty.no_results_body':
    'Réessayez avec un autre terme ou affinez vos résultats grâce à la <a>recherche avancée</a>',
  'product_search_dialog.empty.no_results_body_no_advanced_search': 'Réessayez avec un autre terme',
  'product_search_dialog.empty.no_results_heading':
    "Nous n'avons trouvé aucun résultat correspondant à votre recherche.",
  'product_search_dialog.empty_prequery.error_heading':
    "Une erreur s'est produite avec l'affichage des résultats initiaux",
  'product_search_dialog.empty_prequery.no_results_heading': 'Recherchez ce dont vous avez besoin',
  'product_search_dialog.error.failed_search_body':
    "Ce n'est peut-être que temporaire. La meilleure chose à faire est de <a>réessayer</a>.",
  'product_search_dialog.error.failed_search_heading': "La recherche n'a pas pu aboutir",
  'product_search_dialog.give_feedback': 'Envoyer un commentaire',
  'product_search_dialog.google_drive.files_heading': 'Fichiers',
  'product_search_dialog.inline_onboarding_action': 'OK',
  'product_search_dialog.inline_onboarding_body':
    "Utilisez les onglets Jira et Confluence pour rechercher et afficher les éléments récents dans l'un ou l'autre des emplacements.",
  'product_search_dialog.inline_onboarding_title': 'Rechercher dans Jira et Confluence',
  'product_search_dialog.jira.assignee_filters': 'Filtrer par Personne assignée',
  'product_search_dialog.jira.boards_icon_accessibility_text': 'Icône de tableau',
  'product_search_dialog.jira.boards_projects_filters_plans_section_heading': 'Tableaux, projets, filtres et plans',
  'product_search_dialog.jira.boards_projects_filters_section_heading': 'Tableaux, projets et filtres',
  'product_search_dialog.jira.date_filter_30': '30 j',
  'product_search_dialog.jira.date_filter_60': '60 j',
  'product_search_dialog.jira.date_filter_90': '90 j',
  'product_search_dialog.jira.date_filter_any': 'À tout moment',
  'product_search_dialog.jira.date_filter_past_30_days': '30 derniers jours',
  'product_search_dialog.jira.date_filter_past_7_days': '7 derniers jours',
  'product_search_dialog.jira.date_filter_past_year': 'Année dernière',
  'product_search_dialog.jira.date_filter_today': "Aujourd'hui",
  'product_search_dialog.jira.date_filter_yesterday': 'Hier',
  'product_search_dialog.jira.date_filters': 'Dernière mise à jour',
  'product_search_dialog.jira.empty_prequery.no_results_heading': 'Lancez une recherche pour trouver votre travail',
  'product_search_dialog.jira.issue_filter_done': 'Terminé',
  'product_search_dialog.jira.issue_filter_open': 'Ouvert',
  'product_search_dialog.jira.issue_filters': 'Filtrer par état',
  'product_search_dialog.jira.issue_labels_filters': 'Filtrer par étiquette',
  'product_search_dialog.jira.issue_labels_filters_options_group_label': 'Toutes les étiquettes',
  'product_search_dialog.jira.issue_labels_filters_placeholder': 'Sélectionner une étiquette',
  'product_search_dialog.jira.issues_section_heading': 'Tickets',
  'product_search_dialog.jira.jira_view_all_issues_new': 'Afficher tous les tickets',
  'product_search_dialog.jira.project_filters': 'Filtrer par projet',
  'product_search_dialog.jira.project_filters_find_more': 'Recherchez un projet',
  'product_search_dialog.jira.projects_filters_section_heading': 'Projets et filtres',
  'product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading':
    'Tableaux, projets, filtres et plans récents',
  'product_search_dialog.jira.recent_boards_projects_filters_section_heading': 'Tableaux, projets et filtres récents',
  'product_search_dialog.jira.recent_projects_filters_section_heading': 'Projets et filtres récents',
  'product_search_dialog.jira.recently_viewed_issues_section_heading': 'Tickets récemment consultés',
  'product_search_dialog.jira.report_by_filters': 'Filtrer par rapporteur',
  'product_search_dialog.jira.reported_by_me_filter': "Que j'ai signalés",
  'product_search_dialog.jira.site_filters_find_more': 'Recherchez un site',
  'product_search_dialog.jira.view_all_issues': 'Recherche avancée des tickets',
  'product_search_dialog.loading_filters': 'Chargement',
  'product_search_dialog.more_filters': 'Afficher tous les filtres',
  'product_search_dialog.multi_site_advanced_search_label': 'Rechercher sur :',
  'product_search_dialog.multi_site_advanced_search_more_dropdown': '{count} autres',
  'product_search_dialog.no_options_filters': 'Aucune option',
  'product_search_dialog.opsgenie.advanced_search': "Recherche d'alertes avancée",
  'product_search_dialog.opsgenie.alert_heading': 'Alertes',
  'product_search_dialog.opsgenie.expanded.input-placeholder': 'Recherchez dans Opsgenie',
  'product_search_dialog.opsgenie.opsgenie_recent_alerts': 'Alertes récentes',
  'product_search_dialog.quick_find_ask_atlassian_intelligence': 'Demander à Atlassian Intelligence',
  'product_search_dialog.quick_find_confluence_space': 'Espace Confluence',
  'product_search_dialog.quick_find_footer_full_page_search_link': 'Rechercher dans votre organisation',
  'product_search_dialog.quick_find_footer_text': "Aidez-nous à améliorer l'expérience de recherche",
  'product_search_dialog.quick_find_no_content_body':
    'Recherchez ou demandez tout ce que vous attendez de vos produits Atlassian',
  'product_search_dialog.quick_find_no_content_header': 'Qui cherche trouve',
  'product_search_dialog.quick_find_recent_draft_label': 'BROUILLON',
  'product_search_dialog.quick_find_recent_search': 'Recherche récente',
  'product_search_dialog.quick_find_recent_search_text_dialog': "D'après vos recherches récentes",
  'product_search_dialog.quick_find_recent_spaces_additional_meta': 'Récemment consultés',
  'product_search_dialog.quick_find_recently_viewed': 'Récemment consultés',
  'product_search_dialog.quick_find_result_item_team': 'Équipe',
  'product_search_dialog.quick_find_results_section': 'Résultats de la recherche',
  'product_search_dialog.quick_find_search_input_placeholder': 'Recherchez du contenu ou posez une question',
  'product_search_dialog.quick_find_search_results': 'Résultats de la recherche',
  'product_search_dialog.quick_find_show_filtered_results':
    'Filtrer par espace Confluence, par contributeur, et bien plus encore',
  'product_search_dialog.quick_find_show_organization_results': 'Rechercher dans votre organisation',
  'product_search_dialog.recent_spaces_section_heading': 'Espaces récents',
  'product_search_dialog.recently_viewed_heading': 'Recherche avancée',
  'product_search_dialog.recently_viewed_section_heading': 'Récemment consultés',
  'product_search_dialog.recently_worked_with_section_heading': 'Derniers collaborateurs',
  'product_search_dialog.search_input_collapsed_placeholder': 'Rechercher',
  'product_search_dialog.search_people_link': 'Rechercher des personnes',
  'product_search_dialog.show_all_results_link': 'Afficher tous les résultats',
  'product_search_dialog.show_more_results_link': 'Afficher plus',
  'product_search_dialog.townsquare.search_input_expanded_placeholder': "Rechercher sur la page d'accueil",
  'product_search_dialog.townsquare_goals_heading': 'Objectifs',
  'product_search_dialog.townsquare_goals_view_all': 'Rechercher tous les objectifs',
  'product_search_dialog.townsquare_help_links_heading': "Liens d'aide",
  'product_search_dialog.townsquare_learnings_risks_decisions_heading': 'Apprentissages, risques et décisions',
  'product_search_dialog.townsquare_people_heading': 'Personnes',
  'product_search_dialog.townsquare_people_view_all': 'Rechercher toutes les personnes',
  'product_search_dialog.townsquare_projects_heading': 'Projets',
  'product_search_dialog.townsquare_projects_view_all': 'Rechercher tous les projets',
  'product_search_dialog.townsquare_recent_people': 'Personnes récentes',
  'product_search_dialog.townsquare_recent_topics': 'Rubriques récentes',
  'product_search_dialog.townsquare_teams_heading': 'Équipes',
  'product_search_dialog.townsquare_teams_view_all': 'Rechercher toutes les équipes',
  'product_search_dialog.townsquare_topics_heading': 'Rubriques',
  'product_search_dialog.townsquare_topics_view_all': 'Rechercher toutes les rubriques',
  'product_search_dialog.trello.archived': 'Archivée',
  'product_search_dialog.trello.archived.card-hover': 'Cette carte est archivée',
  'product_search_dialog.trello.board': 'Tableau',
  'product_search_dialog.trello.boards_heading': 'Tableaux',
  'product_search_dialog.trello.cards_heading': 'Cartes',
  'product_search_dialog.trello.closed': 'Fermé',
  'product_search_dialog.trello.closed.board-hover': 'Ce tableau est fermé',
  'product_search_dialog.trello.expanded.input-placeholder': 'Rechercher dans Trello',
  'product_search_dialog.trello.feedback_link': 'Aidez-nous à améliorer les résultats de votre recherche !',
  'product_search_dialog.trello.list': 'Liste',
  'product_search_dialog.trello.private_workspace': 'Espace de travail privé',
  'product_search_dialog.trello.recent_boards_heading': 'Tableaux récents',
  'product_search_dialog.trello.workspace': 'Espace de travail',
  'product_search_dialog.updated_date_formatter': 'Mise à jour : {date}',
  'search_dialog.filters.group.show-more': 'Afficher plus',
  'search_dialog.search_input_clear_label': 'Effacer la session de recherche',
  'search_dialog.search_input_exit_label': 'Quitter la recherche',
};
